"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallBackSuccess = void 0;
var react_1 = __importStar(require("react"));
var AuthenticateError_component_1 = __importDefault(require("./AuthenticateError.component"));
var oidc_1 = __importDefault(require("../../vanilla/oidc"));
var withRouter_1 = require("../routes/withRouter");
var CallBackSuccess = function () { return (react_1.default.createElement("div", { className: "oidc-callback" },
    react_1.default.createElement("div", { className: "oidc-callback__container" },
        react_1.default.createElement("h1", { className: "oidc-callback__title" }, "Authentication complete"),
        react_1.default.createElement("p", { className: "oidc-callback__content" }, "You will be redirected to your application.")))); };
exports.CallBackSuccess = CallBackSuccess;
var CallbackManager = function (_a) {
    var callBackError = _a.callBackError, callBackSuccess = _a.callBackSuccess, configurationName = _a.configurationName, withCustomHistory = _a.withCustomHistory;
    var _b = (0, react_1.useState)(false), error = _b[0], setError = _b[1];
    (0, react_1.useEffect)(function () {
        var isMounted = true;
        var playCallbackAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var getOidc, callbackPath, history_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getOidc = oidc_1.default.get;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getOidc(configurationName).loginCallbackWithAutoTokensRenewAsync()];
                    case 2:
                        callbackPath = (_a.sent()).callbackPath;
                        history_1 = (withCustomHistory) ? withCustomHistory() : (0, withRouter_1.getCustomHistory)();
                        history_1.replaceState(callbackPath || "/");
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (isMounted) {
                            setError(true);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        playCallbackAsync();
        return function () {
            isMounted = false;
        };
    }, []);
    var CallbackErrorComponent = callBackError || AuthenticateError_component_1.default;
    var CallbackSuccessComponent = callBackSuccess || exports.CallBackSuccess;
    if (error) {
        return react_1.default.createElement(CallbackErrorComponent, { configurationName: configurationName });
    }
    return react_1.default.createElement(CallbackSuccessComponent, { configurationName: configurationName });
};
exports.default = CallbackManager;
//# sourceMappingURL=Callback.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@axa-fr/react-oidc/dist/core/default-component/Callback.component.js
// module id = 885
// module chunks = 0